import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";

const authenticationRouter: RouteRecordRaw[] = [
    {
        path: "/authentication",
        name: "AuthenticationCenter",
        redirect: "/authentication/authentication",
        component: () => import("@/views/layouts/index.vue"),
        meta: {
            title: "系统设置",
            icon: "icon-pingtaiguanli"
        },
        children: [
            {
                path: "authentication",
                name: "UnAuthentication",
                component: () => import("@/views/pages/manageCenter/authentication/index.vue"),
                meta: {
                    title: "认证",
                    isNotShowHeader: true,
                    activeMenu: "UnAuthentication",
                    pageType: PAGE_TYPE.CACHE_FORM.code
                }
            }
        ]
    }
];

export default authenticationRouter;
